
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  setup() {
    const router = useRouter()
    const { t } = useI18n()

    return {
      t,
      router,
    }
  },
})
